import { Query } from 'acast-reactor';

export default (queryName, ...args) => {
  let tx;

  try {
    tx = Query.run(queryName, ...args);
  } catch (e) {
    if (/unknown query/gi.test(e.message)) {
      tx = Query.run('Query/delegate', {
        query: queryName,
        args,
      });
    } else {
      throw e;
    }
  }

  if (!tx) {
    throw new Error(`Failed to run query ${queryName}`);
  }

  return tx.asPromise();
};
